<template>
    <div>
		<transition name="fade">
		    <Row v-if="mainTable.brandShow"
		        :gutter="16">
		        <Col span="24">
		        <search-card :form="mainTable.brandForm"
		            :table-load-event="getMainTableRecords"
		            :table-search="mainTable.tableSearch" />
		        </Col>
		    </Row>
		</transition>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">品牌管理</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="$checkAccessArray(['S'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreate">新增</Button>
						<Button type="primary"
						    size="small"
						    class="btns"
						    shape="circle"
						    icon="ios-search"
						    @click="mainTable.brandShow = !mainTable.brandShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <Form v-if="formShow"
                    ref="brandForm"
                    :model="form"
                    :rules="ruleValidate"
                    label-position="top"
                    class="small-form border">
                    <Row :gutter="16">
                        

                        <Col span="6">
                        <FormItem label="品牌名称"
                            prop="brandName">
                            <Input v-model="form.brandName"></Input>
                        </FormItem>
                        </Col>

                        <!-- <Col span="4">
                        <FormItem label="品牌编码"
                            prop="brandCode">
                            <Input v-model="form.brandCode"></Input>
                        </FormItem>
                        </Col> -->
						
						<Col span="4">
						<FormItem label="所属苗场"
						    prop="seedFarmName">
						    <Input v-model="form.seedFarmName"></Input>
						</FormItem>
						</Col>
						
                        <Col span="4">
                        <FormItem label="主图">
                            <single-file-upload-with-name v-model="form.brandMainImageFile" />
                        </FormItem>
                        </Col>
                        <Col span="4">
                        <FormItem label="缩图">
                            <single-file-upload-with-name v-model="form.brandThumbnailFile" />
                        </FormItem>
                        </Col>
                    </Row>

                    <Row :gutter="16">
                        <Col span="6">
                        <FormItem label="备注">
                            <Input v-model="form.brandRemark"></Input>
                        </FormItem>
                        </Col>
                    </Row>

                    <Row>
                        <Col span="24">
                        <Button v-if="$checkAccessArray(['S'])"
                            type="success"
                            @click="onSave">保存
                        </Button>
                        <Button type="text"
                            @click="formShow = false">取消
                        </Button>
                        </Col>
                    </Row>
                </Form>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import SingleFileUploadWithName from '@/components/single-file-upload-with-name/SingleFileUploadWithName';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { singleImageRender } from '@/libs/tableRowImageRender';

import { getBrandList, saveBrand } from '@/api/modules/product-management/brand-management';

export default {
    name: 'BrandList',
    components: {
        SearchCard,
        SingleFileUploadWithName,
        StandPaginationTable
    },
    data() {
        return {
            mainCategorySource: [],
            mainTable: {
                tableColumns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '品牌名称', key: 'brandName', align: 'center' },
                    // { title: '品种名称', key: 'brandVarietyName', align: 'center' },
                    // { title: '品牌编码', key: 'brandCode', align: 'center' },
                    // { title: '缩略图', align: 'center', render: (h, params) => singleImageRender(h, params.row.brandThumbnailFile) },
                    // { title: '品牌图', align: 'center', render: (h, params) => singleImageRender(h, params.row.brandMainImageFile) },
                    { title: '所属苗场', key: 'seedFarmName', align: 'center' },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 150,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                        // visibility: this.$checkAccessArray(['B', 'C']) ? 'visible' : 'hidden'
                                    },
                                    on: {
                                        click: () => {
                                            this.onUpdate(params.row);
                                        }
                                    }
                                }, '编辑')
                            ]);
                        }
                    }
                ],
                tableData: [],
                brandShow:false,
                brandForm:[
                    { label: '品牌名称', type: 'Input', value: '', name: 'brandName', sql: 'like' },
                    // { label: '品牌编码', type: 'Input', value: '', name: 'brandCode', sql: 'like' },
                    { label: '所属苗场', type: 'Input', value: '', name: 'seedFarmName', sql: 'like' }
                ],
                tableLoading: false,
                tableSearch: search.getSearchParams()
            },
            form: {
                formEditMode: '',
                brandUuid: '',
                brandName: '',
                // brandCode: '',
                brandThumbnailFile: '',
                brandMainImageFile: '',
                brandRemark: '',
                seedFarmName: ''
            },
            formShow: false,
            ruleValidate: {
                brandName: [{ required: true, message: ' ', trigger: 'blur' }],
                // brandCode: [{ required: true, message: ' ', trigger: 'blur' }],
                seedFarmName: [{ required: true, message: ' ', trigger: 'blur' }]
            }
        };
    },
    beforeRouteLeave(to, from, next) {
        this.mainTable.tableData = [];
        this.$destroy();
        next();
    },
    computed: {
        // canAddNewBrand() {
        //     return this.mainTable.tableData.length === 0;
        // }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getBrandList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        },
        onCreate() {
            this.form.formEditMode = FORM_EDIT_MODE_CREATE;
            this.form.brandUuid = '';
            this.form.brandName = '';
            // this.form.brandCode = '';
            this.form.brandThumbnailFile = '';
            this.form.brandMainImageFile = '';
            this.form.brandRemark = '';
            this.form.seedFarmName = '';

            this.formShow = true;
        },
        onUpdate(row) {
            this.form.formEditMode = FORM_EDIT_MODE_MODIFY;
            this.form.brandUuid = row.brandUuid;
            this.form.brandName = row.brandName;
            // this.form.brandCode = row.brandCode;
            this.form.brandThumbnailFile = row.brandThumbnailFile;
            this.form.brandMainImageFile = row.brandMainImageFile;
            this.form.brandRemark = row.brandRemark;
            this.form.seedFarmName = row.seedFarmName;

            this.formShow = true;
        },
        onSave() {
            this.$refs.brandForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return;
                }

                const data = Object.assign({}, this.form);
                saveBrand(data).then(res => {
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            content: '',
                            onOk: () => {
                                window.location.reload();
                            }
                        });
                    }
                });
            });
        }
    }
};
</script>

<style scoped lang="less">
@titleHeight: 25px;

.border {
    border: 1px solid #c9c9c9;
    margin-bottom: 5px;
    padding: 5px 5px 5px 5px;
}

.title {
    height: @titleHeight;

    .text {
        font-weight: bold;
        float: left;
        line-height: @titleHeight;
    }

    .action {
        float: right;
    }
}
</style>
